"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FDateTimeField = void 0;
const react_1 = __importDefault(require("react"));
const formik_1 = require("formik");
const DateTimeTextField_1 = require("./DateTimeTextField");
function FDateTimeField({ onChange, ...props }) {
    //eslint-disable-next-line
    const [{ onChange: _oc, ...field }, meta, helper] = formik_1.useField(props.field);
    return (react_1.default.createElement(DateTimeTextField_1.DateTimeTextField, Object.assign({}, props, field, { onChange: (dateTime) => {
            helper.setValue(dateTime);
            onChange && onChange(dateTime);
        }, error: Boolean(meta.touched && meta.error), helperText: meta.touched && meta.error ? meta.error : '' })));
}
exports.FDateTimeField = FDateTimeField;
